// FIXME: Clear query errors when navigating to automatically retry when going
import { usePrevious } from "@chakra-ui/react";
import { useQueryClient } from "@tanstack/react-query";
//  back to page with the query. Workaround for this issue:
//  https://github.com/TanStack/query/issues/2712#issuecomment-1271679485
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const useResetFailedQueriesOnNavigation = () => {
  const queryClient = useQueryClient();
  const location = useLocation();
  const prevLocation = usePrevious(location);
  useEffect(() => {
    if (location !== prevLocation) {
      void queryClient
        .getQueryCache()
        .getAll()
        .filter(
          (query) =>
            query.state.status === "error" && query.getObserversCount() === 0,
        )
        .map((query) => query.queryKey)
        .map((queryKey) => queryClient.resetQueries({ queryKey }));
    }
  }, [queryClient, location, prevLocation]);
};

export const AppFailedQueryReset: React.FC = () => {
  useResetFailedQueriesOnNavigation();
  return null;
};
